export const getUserInitials = (userName: string): string => {
  return userName
    .match(/(^\S\S?|\s\S)?/g)
    .map((v) => v.trim())
    .join('')
    .match(/(^\S|\S$)?/g)
    .join('')
    .toLocaleUpperCase();
};
